import React, { useState } from "react";
import ReactSimplyCarousel from "react-simply-carousel";
import { Avatar, Card } from "antd";
import { PhoneOutlined, MailOutlined, MobileOutlined } from "@ant-design/icons";
const { Meta } = Card;

const Testimonials: React.FC = () => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  return (
    <div className="testimonials-page">
      <h2>Testimonials</h2>
      <div className="testimonials-wrapper">
        <div></div>
        <div>
          <ReactSimplyCarousel
            activeSlideIndex={activeSlideIndex}
            onRequestChange={setActiveSlideIndex}
            itemsToShow={1}
            itemsToScroll={1}
            forwardBtnProps={{
              //here you can also pass className, or any other button element attributes
              style: {
                alignSelf: "center",
                background: "black",
                border: "none",
                borderRadius: "50%",
                color: "white",
                cursor: "pointer",
                fontSize: "20px",
                height: 30,
                lineHeight: 1,
                textAlign: "center",
                width: 30,
              },
              children: <span>{`>`}</span>,
            }}
            backwardBtnProps={{
              //here you can also pass className, or any other button element attributes
              style: {
                alignSelf: "center",
                background: "black",
                border: "none",
                borderRadius: "50%",
                color: "white",
                cursor: "pointer",
                fontSize: "20px",
                height: 30,
                lineHeight: 1,
                textAlign: "center",
                width: 30,
              },
              children: <span>{`<`}</span>,
            }}
            responsiveProps={[
              {
                itemsToShow: 1,
                itemsToScroll: 1,
                minWidth: 768,
              },
            ]}
            speed={400}
            easing="linear"
          >
            <div className="testimonials-slide">
              <p className="">
                Aliquam pellentesque vehicula nibh a rhoncus. Morbi molestie ex
                non sem tristique interdum. Aenean auctor lorem a lacinia
                feugiat. Phasellus scelerisque ligula elit, interdum tempus
                libero fermentum in. Cras ac varius purus. Ut augue mi, commodo
                blandit vulputate vel, lacinia sed nunc. In hac habitasse platea
                dictumst. Orci varius natoque penatibus et magnis dis parturient
                montes, nascetur ridiculus mus.
              </p>
              <div className="client-wrapper">
                <Meta
                  avatar={
                    <Avatar
                      shape="square"
                      size={80}
                      src="https://api.dicebear.com/7.x/miniavs/svg?seed=8"
                      className="rainbow-shadow"
                    />
                  }
                  title="Anpu Painting"
                  description=""
                />
              </div>
            </div>
            <div className="testimonials-slide">
              <p className="">
                Aliquam pellentesque vehicula nibh a rhoncus. Morbi molestie ex
                non sem tristique interdum. Aenean auctor lorem a lacinia
                feugiat. Phasellus scelerisque ligula elit, interdum tempus
                libero fermentum in. Cras ac varius purus. Ut augue mi, commodo
                blandit vulputate vel, lacinia sed nunc. In hac habitasse platea
                dictumst. Orci varius natoque penatibus et magnis dis parturient
                montes, nascetur ridiculus mus.
              </p>
              <div className="client-wrapper">
                <Meta
                  avatar={
                    <Avatar
                      shape="square"
                      size={80}
                      src="https://api.dicebear.com/7.x/miniavs/svg?seed=8"
                      className="rainbow-shadow"
                    />
                  }
                  title="Anpu Painting"
                  description=""
                />
              </div>
            </div>
            <div className="testimonials-slide">
              <p className="">
                Aliquam pellentesque vehicula nibh a rhoncus. Morbi molestie ex
                non sem tristique interdum. Aenean auctor lorem a lacinia
                feugiat. Phasellus scelerisque ligula elit, interdum tempus
                libero fermentum in. Cras ac varius purus. Ut augue mi, commodo
                blandit vulputate vel, lacinia sed nunc. In hac habitasse platea
                dictumst. Orci varius natoque penatibus et magnis dis parturient
                montes, nascetur ridiculus mus.
              </p>
              <div className="client-wrapper">
                <Meta
                  avatar={
                    <Avatar
                      shape="square"
                      size={80}
                      src="https://api.dicebear.com/7.x/miniavs/svg?seed=8"
                      className="rainbow-shadow"
                    />
                  }
                  title="Anpu Painting"
                  description=""
                />
              </div>
            </div>
          </ReactSimplyCarousel>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
